export default __webpack_public_path__ + "static/media/Crest-Whitening-Strips2.f0ae699c.png";